import { CustomElement } from './custom-element';

export class InlineCustomElement extends CustomElement {
    onEmbedClick = event => {
        if (event.target === event.currentTarget) {
            event.stopPropagation();
            this.showPlayer();
        }
    }

    showPlayer(event) {
        if (!this.displayed) {
            super.showPlayer(event);
        }
    }

    hidePlayer(event) {
        // do nothing;
    }

    get presentation() {
        return 'inline';
    }
}